define.alias("ember-math-helpers/helpers/asin", "settings/helpers/asin");